import React, { memo } from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';

const styles: { [className: string]: SxProps<Theme> } = {
  messageHeader: {
    display: 'inline-block',
    direction: 'ltr',
    textAlign: 'center',
    fontSize: 26,
    color: 'customStyling.headlineColor',
    fontWeight: 700,
    lineHeight: '43px',
    maxWidth: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    '@media (min-width: 769px)': {
      fontSize: 36,
    },
    wordBreak: 'break-word',
    wordWrap: 'break-word',
  },
};

export interface IMessageHeaderProps {
  text: string;
}

const MessageHeader = ({ text }: IMessageHeaderProps) => (
  <Box display="inline-block" maxWidth={500} mt={4} mb={[0, 4]} mx={[1, 'auto']}>
    <Typography data-testid="giftMessageHeader" sx={styles.messageHeader}>
      {text}
    </Typography>
  </Box>
);

export default memo(MessageHeader);
